import { render, staticRenderFns } from "./European.vue?vue&type=template&id=1354b04f&scoped=true"
import script from "./European.vue?vue&type=script&lang=js"
export * from "./European.vue?vue&type=script&lang=js"
import style0 from "./European.vue?vue&type=style&index=0&id=1354b04f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1354b04f",
  null
  
)

export default component.exports